(() => {
  const drawer = document.querySelector('[data-sgm-mobile-menu]');
  if (!drawer) return;

  const html = document.documentElement;
  const openers = document.querySelectorAll('[data-sgm-menu-open]');

  const esc = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'));
  const allPanels = () => Array.from(drawer.querySelectorAll('[data-sgm-panel]'));

  let stack = ['root'];
  let lastFocus = null;

  const setExpanded = (value) => {
    openers.forEach((b) => b.setAttribute('aria-expanded', value ? 'true' : 'false'));
  };

  const setPanelsState = () => {
    const activeId = stack[stack.length - 1];

    allPanels().forEach((p) => {
      const id = p.getAttribute('data-sgm-panel');
      const isActive = id === activeId;

      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      // Push effect
      const idx = stack.indexOf(id);
      if (idx === -1) {
        p.classList.remove('is-left');
        p.classList.add('is-right');
      } else {
        p.classList.remove('is-right');
        p.classList.toggle('is-left', idx < stack.length - 1);
      }
    });
  };

  const lockScroll = (locked) => html.classList.toggle('sgm-menu-open', locked);

  const focusFirst = () => {
    const sheet = drawer.querySelector('.sgm-drawer__sheet');
    if (!sheet) return;

    const focusable = sheet.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) focusable.focus();
  };

  const open = () => {
    if (!drawer.hasAttribute('hidden')) return;

    lastFocus = document.activeElement;
    drawer.removeAttribute('hidden');
    lockScroll(true);

    stack = ['root'];
    setPanelsState();
    setExpanded(true);
    focusFirst();
  };

  const close = () => {
    if (drawer.hasAttribute('hidden')) return;

    drawer.setAttribute('hidden', '');
    lockScroll(false);

    stack = ['root'];
    setPanelsState();
    setExpanded(false);

    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const push = (panelId) => {
    if (!panelId) return;
    const target = drawer.querySelector(`[data-sgm-panel="${esc(panelId)}"]`);
    if (!target) return;

    stack.push(panelId);
    setPanelsState();
  };

  const back = () => {
    if (stack.length <= 1) return;
    stack.pop();
    setPanelsState();
  };

  // Open triggers
  openers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });
  });

  // Drawer click delegation
  drawer.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-sgm-menu-close]');
    if (closeBtn) {
      e.preventDefault();
      close();
      return;
    }

    const backBtn = e.target.closest('[data-sgm-menu-back]');
    if (backBtn) {
      e.preventDefault();
      back();
      return;
    }

    const pushEl = e.target.closest('[data-sgm-menu-push]');
    if (pushEl) {
      const panelId = pushEl.getAttribute('data-sgm-menu-push');
      const target = drawer.querySelector(`[data-sgm-panel="${esc(panelId)}"]`);

      // Se esiste il pannello, facciamo push; altrimenti lasciamo navigare
      if (target) {
        e.preventDefault();
        push(panelId);
      }
    }
  });

  // ESC to close
  drawer.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
